import React, { useRef } from 'react';
import {
  IonItemSliding,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonImg
} from '@ionic/react';
import { Shipping } from '../models/Shipping';

interface ShippingCardProps {
  shipping?: Shipping;
  hide: boolean;
}

const ShippingCard: React.FC<ShippingCardProps> = ({
  shipping,
  hide,
}) => {
  const ionItemSlidingRef = useRef<HTMLIonItemSlidingElement>(null);

  if (!shipping) {
    return (
      <IonList>
        {/* <IonListHeader>データがありません。</IonListHeader> */}
      </IonList>
    );
  }

  return (
    <IonItemSliding
      ref={ionItemSlidingRef}
      class={'track-' + shipping.jan.toLowerCase()}
      style={hide ? { display: 'none' } : {}}
    >
      {(shipping.image !== "") && 
      <IonItem>
        <IonImg src={shipping.image} alt="Shipping Image" style={{ width: '200px', height: '200px' }} />
      </IonItem>
      }
      <IonItem>
        <IonLabel>
          <p style={{ fontSize: '20px', lineHeight: '30px' }}>
            注文番号 : {shipping.order_num}
          </p>
        </IonLabel>
      </IonItem>
    </IonItemSliding>
  );
};

export default React.memo(ShippingCard);
